import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import ValentinesDayPromotionComponent from './ValentinesDayPromotion';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    root: {
      padding: theme.spacing(0, 2, 2, 2),
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    content: {
      width: '100%',
      maxWidth: 900,
    },
  })
);

export type FestivePromotionOptions = 'valentinesDay' | undefined;

// set this to enable promotions, or null to disable promotions
export const ACTIVE_PROMOTION: FestivePromotionOptions = 'valentinesDay';

export const VALENTINES_DAY_QUERY = 'find my valentine';

export const getFestivePromotion = (str: string): FestivePromotionOptions => {
  // no promotion activated
  if (!ACTIVE_PROMOTION || !str) return;

  if (
    ACTIVE_PROMOTION === 'valentinesDay' &&
    str.toLowerCase() === VALENTINES_DAY_QUERY
  ) {
    return 'valentinesDay';
  }

  return;
};

export interface FestivePromotionProps {
  variant: FestivePromotionOptions;
}

export const FestivePromotion = ({ variant }: FestivePromotionProps) => {
  const classes = useStyles();

  if (!variant) return <></>;

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        {variant === 'valentinesDay' && <ValentinesDayPromotionComponent />}
      </div>
    </div>
  );
};

export default FestivePromotion;
